$ = null
const cfg = {
  articles_per_page: 3,
  articles_per_page_mobile: 2,
  totalArticles: 0,
  page: 0,
}

export function initRelatedArticles(jQuery) {
  $ = jQuery

  if(!$('.section-wrapper--related-articles').length) {
    return
  }

  // Show initial related articles
  cfg.totalArticles = $('.flow-container .flow-block').length

  // Show first page of articles
  showNextRelatedArticles(null)

  // Add handler on load more to show more articles
  $(document).on("click", ".section-wrapper--related-articles .load-more-button", showNextRelatedArticles);
}

function showNextRelatedArticles(e) {
  cfg.page += 1

  if(cfg.page > 1) {
    $('.section-wrapper--related-articles').addClass('dont-hide-last-article')
  }

  const is_mobile = $(window).outerWidth() < 768

  const parent = $('.section-wrapper--related-articles .flow-container')

  const activeArticles = cfg.page * (is_mobile? cfg.articles_per_page_mobile : cfg.articles_per_page) // multiplies pages with how many per page. 3 pages x 3 articles is nine.
  const makeArticlesEven = is_mobile ? activeArticles % 2 : 0 // Make sure we always have an even number of articles visible, for mobile

  console.log('cfg.page', cfg.page)
  console.log('activeArticles', activeArticles)
  console.log('makeArticlesEven', makeArticlesEven)
  console.log('activeArticles + makeArticlesEven', activeArticles + makeArticlesEven)
  $(`.flow-block:lt(${activeArticles + makeArticlesEven})`, parent).addClass("active");

  // Check if we need to hide the loadMore button
  if ($(".flow-block:not(.active)", parent).length <= 0) {
    $(".section-wrapper--related-articles .load-more-container").addClass("hidden");
  }
}



// WEBPACK FOOTER //
// ./assets/js/modules/related-articles.js